import { render, staticRenderFns } from "./VideoNoteContent.vue?vue&type=template&id=4395e343&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/components/VideoNoteContent.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/components/VideoNoteContent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395e343",
  null
  
)

export default component.exports